import type { SignUpFormCopy } from './models';
import { text as moduleText } from './text';
import { text as sharedText } from '@shared/text';

export const text = {
  signUpFormCopy(isSubmitting: boolean): SignUpFormCopy {
    return {
      title: moduleText.title,
      subtitle: moduleText.subtitle,
      submitButtonLabel: isSubmitting ? sharedText.loading : moduleText.submit,
      togglePrompt: moduleText.loginPrompt,
      toggleActionLabel: moduleText.loginAction,
    };
  },
};
